import HolifyaLogoComplete from "@/components/HolifyaLogoComplete";
import LoadingSpinner from "@/components/LoadingSpinner";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchUserData } from "../hooks/useFetchUserData";

const FetchUserData = () => {
    const { fetchUserData, error, isLoading, isAdminRedirecting, isVenereRedirecting } = useFetchUserData();
    const navigate = useNavigate();

    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    // ********************************************************************************
    // TODO [TM]: Dimensioni testi e spazio verticale
    return (
        <div className="w-full h-screen flex flex-col items-center">
            <div className="w-full h-full flex items-center justify-center">
                <div className="flex flex-col items-center px-[20px] space-y-[30px]">
                    <HolifyaLogoComplete />
                    
                    {/* ADMIN REDIRECT STATE */}
                    {isAdminRedirecting && (
                        <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                            <div className="font-bold text-[25px] leading-[33px]">
                                👑 Accesso Admin
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center">
                                Stai per essere reindirizzato alla dashboard amministrativa...
                            </div>
                            <div><LoadingSpinner /></div>
                        </div>
                    )}

                    {/* VENERE REDIRECT STATE */}
                    {isVenereRedirecting && (
                        <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                            <div className="font-bold text-[25px] leading-[33px]">
                                🌙 Venere Project User
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center">
                                Stai per essere reindirizzato alla dashboard del Progetto Venere...
                            </div>
                            <div><LoadingSpinner /></div>
                        </div>
                    )}

                    {/* LOADING STATE */}
                    {isLoading && !isAdminRedirecting && !isVenereRedirecting && (
                        <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                            <div className="font-bold text-[25px] leading-[33px]">
                                ⏳ Attendi...
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center">
                                Stiamo caricando i tuoi dati...
                            </div>
                            <div><LoadingSpinner /></div>
                        </div>
                    )}

                    {/* ERROR STATE */}
                    {!isLoading && !isAdminRedirecting && !isVenereRedirecting && error && (
                        <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                            <div className="font-bold text-[25px] leading-[33px]">
                                ❌ Errore
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center">
                                Qualcosa è andato storto, ti chiediamo ti riprovare
                            </div>
                            <Button size="form" onClick={fetchUserData}>
                                Riprova
                            </Button>
                            <Button variant="outline" size="form" onClick={() => navigate("/")}>
                                Torna alla login page
                            </Button>
                        </div>
                    )}

                    {/* FALLBACK STATE - Show loading if no other state is active */}
                    {!isLoading && !isAdminRedirecting && !isVenereRedirecting && !error && (
                        <div className="flex flex-col items-center px-[20px] space-y-[20px]">
                            <div className="font-bold text-[25px] leading-[33px]">
                                ⏳ Inizializzazione...
                            </div>
                            <div className="font-normal text-[16px] leading-[24px] text-center">
                                Stiamo preparando la tua area riservata...
                            </div>
                            <div><LoadingSpinner /></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default FetchUserData
